angular.module("app").controller("NotificationsController", [
    '$scope',
    'notificationService',
    'errorHandler',
    '$state',
    function ($scope, notificationService, errorHandler, $state) {


        /*
         *@ngdoc method
         *@name getNotifications
         *@description get notifications list
        */
        (getNotifications = function () {
            notificationService.getUserNotifications().then(
                function (response) {
                    if (response && response.status === "ok") {
                        $scope.notifications = angular.copy(response.notifications.items) || {};
                        $scope.notificationsCount = angular.copy(response.notifications.total_count) || undefined;
                    } else {
                        errorHandler((response) ? response.message : "");
                    }
                },
                function (response) {
                    errorHandler((response) ? response.message : "");
                }
            );
        })();


        /*
         *@ngdoc method
         *@name open
         *@description When you want open notification
        */
        $scope.open = function (userNotificationId, type, tableId) {
            notificationService.readNotification(userNotificationId).then(
                function (response) {
                    if (response && response.status === "ok") {
                        type === 'config' && tableId && $state.go("main.configs.general", {configId : tableId});
                        getNotifications();
                    } else {
                        errorHandler((response) ? response.message : "");
                    }
                },
                function (response) {
                    errorHandler((response) ? response.message : "");
                }
            );
        };


        /*
         *@ngdoc method
         *@name deleteNotification
         *@description When you want deleted notification
        */
        $scope.deleteNotification = function (userNotificationId) {
            $scope.open(userNotificationId)
        }


    }
]);